export {
  SessionProvider,
  SubjectTracker,
  ViewTracker,
  ClickTracker,
} from './tracker.js';
import React from 'react';
import { ClickTracker, ViewTracker } from './tracker.js';

function view(tag) {
  return function ViewComponent({ children, ...rest }) {
    return React.createElement(ViewTracker, { ...rest, tag }, children);
  };
}

function click(eventName) {
  return function ClickComponent({ children, ...rest }) {
    return React.createElement(ClickTracker, { ...rest, eventName }, children);
  };
}

export const ProfileView = view('products.show');
export const PricingView = view('products.pricing');
export const CompetitorsView = view('products.competitors');
export const CategoryView = view('categories.show');
export const CompareView = view('comparisons.show');
export const WriteReviewView = view('reviewers.take_survey');
export const AdClick = click('/ad/clicked');
export const LeadCreateClick = click('/leads/create');
